export default __webpack_public_path__ + "assets/images/Payment_05.3699e0.avif";